/***********************************************
 *  1. export animation from After Effects using bodymovin plugin (see: https://airbnb.io/lottie/#/)
*   2. create new folder containing the exported data.json and animation assets in themes/braindo/assets/animations/
*   3. in ACF, add a new option to Sections/Lottie Animation Section/Lottie Animation Name. Choice value must be the same as the name of the folder just created in step 2.
*   4. add any specific stylings to the dev/assets/scss/animations folder
************************************************/

var animationsPath = '../../../wp-content/themes/braindo/assets/animations/';

$(document).ready(function () {
  var $lottieAnimations = $("[data-animations*='lottieAnimation']");

  $lottieAnimations.each(function() {
    setLottieAnimation($(this));
  });
});

function setLottieAnimation($section) {
  var $element = $section.find(".animation-element");
  var animationName = $element.data("animation-name");

  window[animationName] = bodymovin.loadAnimation({
    container: $element[0],
    renderer: 'svg',
    loop: false,
    autoplay: false,
    path: animationsPath + "/" + animationName + "/data.json"
  });

  window[animationName].addEventListener('DOMLoaded', function () {
    Waypoint.refreshAll();
  });
}

function lottieAnimation($section) {
  var $element = $section.find(".animation-element");

  if ($element.hasClass("animate")) {
    var animationName = $element.data("animation-name");

    window[animationName].play();

    $element.removeClass("animate");
  }
}